/** Shared empty placeholder for view-mode fields; muted so filled values stand out. */
export const EMPTY_VALUE = '–';
export const EMPTY_VALUE_CLASS = 'text-default-400';
